// Data Contracts
import { ClerkReviewQueryRequest } from '@data-contracts';

/**
 * A type alias of ClerkReviewQueryRequest property names.
 */
export type PayloadKeys = keyof ClerkReviewQueryRequest;

/**
 * An interface to type the otherFilterFields properties.
 */
export interface IOtherFilterField {
  caption: string;
  propertyName: PayloadKeys;
}

/**
 * An interface to type the otherFilterFields constant.
 */
export interface IOtherFilterFields {
  authorizer: IOtherFilterField;
  authorizersFirm: IOtherFilterField;
  caseName: IOtherFilterField;
  caseNumber: IOtherFilterField;
  caseType: IOtherFilterField;
  division: IOtherFilterField;
  documentTitle: IOtherFilterField;
  documentType: IOtherFilterField;
  sender: IOtherFilterField;
  sendersFirm: IOtherFilterField;
  transaction: IOtherFilterField;
}

/**
 * A constant of assembled ICaptionAndProperty objects for "Other Filters".
 */
export const otherFilterFields: IOtherFilterFields = {
  authorizer: {
    caption: 'Authorizer',
    propertyName: 'authorizerName',
  },
  authorizersFirm: {
    caption: "Authorizer's Firm",
    propertyName: 'authorizerFirm',
  },
  caseName: {
    caption: 'Case Name',
    propertyName: 'caseName',
  },
  caseNumber: {
    caption: 'Case Number',
    propertyName: 'caseNumber',
  },
  caseType: {
    caption: 'Case Type',
    propertyName: 'caseType',
  },
  division: {
    caption: 'Division',
    propertyName: 'division',
  },
  documentTitle: {
    caption: 'Document Title',
    propertyName: 'documentTitle',
  },
  documentType: {
    caption: 'Document Type',
    propertyName: 'filingType',
  },
  sender: {
    caption: 'Sender',
    propertyName: 'sender',
  },
  sendersFirm: {
    caption: "Sender's Firm",
    propertyName: 'senderFirm',
  },
  transaction: {
    caption: 'Transaction',
    propertyName: 'filingId',
  },
};
